import React from 'react'
import ForgotPasswordContainer from '../../containers/forgotpassword';
import {useSearchParams } from 'react-router-dom';

const ForgotPasswordPage = (props) => {
    const {request_type} = props;
    const [searchParams] = useSearchParams();
    const token = searchParams.get('oft');
    return <ForgotPasswordContainer request_type={request_type} token={token}/>
}

export default ForgotPasswordPage;
